import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { Loader } from "rsuite";
import { axInst } from "../../../Components/Login/Service";
import WaterMark from "../../../Components/WaterMark/WaterMark.jsx";
import BarCharts from "../../Complaint/ComplaintCharts/VerticalBarChart.js";

const mismatchApi = async (body) => {
  try {
    const res = await axInst.post("/dealer-review/mismatch_data", body);
    const responseData = res.data;

    if (typeof responseData !== "object" || responseData === null) {
      console.error("Invalid API response format:", responseData);
      return [];
    }

    return Object.entries(responseData).map(([key, value]) => ({
      keyData: key,
      valData: value,
    }));
  } catch (error) {
    console.error("Error fetching mismatch data:", error);
    return [];
  }
};

const Mismatch = () => {
  const { data, submitted } = useSelector((e) => e.filtersDealerReview);

  const {
    data: mismatchData = [],
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["mismatch", submitted],
    queryFn: () => mismatchApi(data),
    cacheTime: 0,
    staleTime: 0,
  });

  // const hasValidData = mismatchData.some(
  //   (item) => typeof item.valData === "number" && item.valData >= 0
  // );

  return (
    <div className="bg-white rounded-md p-2 relative h-full">
      <WaterMark />
      {isFetching ? (
        <div className="grid items-center justify-center w-full h-full">
          <Loader />
        </div>
      ) : isError || mismatchData.length === 0 ? (
        <div className="grid items-center justify-center w-full h-full">
          <p>Data not available</p>
        </div>
      ) : (
        //  : !hasValidData ? (
        //   <div className="grid items-center justify-center w-full h-full">
        //     <p>Not Applicable</p>
        //   </div>
        // )
        <BarCharts
          line={false}
          color={"#E5CA83"}
          xaxisdata={mismatchData.map((item) => item.keyData)}
          yaxisdata={mismatchData.map((item) =>
            typeof item.valData === "number" ? item.valData : 0
          )}
          heading={"Channel Finance - Net Mismatch(in Cr.)"}
          headingColor={"#1F2937"}
          headingFont={"18"}
        />
      )}
    </div>
  );
};

export default Mismatch;
